module.exports = __webpack_public_path__ + "img/en_1.1208d134.jpg";